import DateBox from 'devextreme-react/date-box';
import TextBox from 'devextreme-react/text-box';

import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Modal } from 'semantic-ui-react';
import { DefaultButton, PrimaryButton } from '../../../components/editor/button';
import ComboboxChienDich from "../../../components/editor/cmb_chiendich";
import ComboboxGioiTinh from "../../../components/editor/cmb_gioitinh";
import ComboboxNamHoc from "../../../components/editor/cmb_namhoc";
import { InValidMessage } from "../../../components/editor/invalid_message";
import { FormGroup } from "../../../components/form-group";
import { useCommonContext } from '../../../contexts/common';


import { hoSoSurveyApi } from '../../../api/hoSoSurveyApi';
import { showNotify } from '../../../helpers/toast';
const HoSoSurveyModal = ({ id, onCancel, onSuccess }) => {
    const [isSaving, setIsSaving] = useState(false)
    const { translate } = useCommonContext();
    const { register, trigger, errors } = useForm();
    const [formData, setFormData] = useState({});
    const [isValidUniqueKey, setIsValidUniqueKey] = useState(true);
    useEffect(() => {
        handleReloadDetail();
    }, [id]);
    useEffect(() => {
        if (formData.ho_ten && formData.ngay_sinh && formData.dien_thoai_lien_he) {
            handleCheckValidUniqueKey();
        }
    }, [id, formData.ho_ten, formData.ngay_sinh, formData.dien_thoai_lien_he]);
    const handleReloadDetail = async () => {
        const res = await hoSoSurveyApi.Detail(id);
        if (res.is_success) {
            setFormData({ ...res.data })
        }
    }
    const handleCheckValidUniqueKey = async () => {
        const res = await hoSoSurveyApi.ValidateUniqueKey({
            id: id || 0,
            ho_ten: formData.ho_ten,
            ngay_sinh: formData.ngay_sinh,
            dien_thoai_lien_he: formData.dien_thoai_lien_he
        });
        if (res.is_success) {
            setIsValidUniqueKey(true);
        } else {
            setIsValidUniqueKey(false);
        }
    }
    const handleSubmit = async () => {
        trigger().then(async (isValid) => {
            if (isValid) {
                setIsSaving(true);
                let res;
                if (id > 0) {
                    res = await hoSoSurveyApi.Update(formData);
                } else {
                    res = await hoSoSurveyApi.Insert(formData);
                }
                setIsSaving(false);
                if (res.is_success) {
                    showNotify({ text: "Cập nhật thành công", type: "success" })
                    onSuccess();
                } else {
                    showNotify({ text: "Cập nhật không thành công", type: "error" })
                }
            }
        })
    }
    return (
        <>
            <Modal
                open={true}
                size="small"

                onClose={onCancel}
                closeOnEscape={false}
                closeOnDimmerClick={false}
            >
                <Modal.Header>
                    {id > 0 ? (
                        <p>{translate('Cập nhật')}</p>
                    ) : (
                        <p>{translate('Thêm mới')}</p>
                    )}
                </Modal.Header>
                <Modal.Content>
                    <form className="ui">
                        <input className="hide" name="id" defaultValue={formData.id}></input>
                        <div className="row">
                            <div className="col-md-4">

                                <FormGroup label={"Năm học"}>
                                    <ComboboxNamHoc
                                        value={formData.nam_hoc}
                                        width={"100%"}
                                        onValueChanged={(value) => {
                                            setFormData({ ...formData, nam_hoc: value });
                                            trigger("nam_hoc")
                                        }} />
                                    <InValidMessage
                                        name="nam_hoc"
                                        defaultValue={formData.nam_hoc}
                                        register={register({ required: true })}
                                        errors={errors}
                                        message={'Vui lòng chọn năm học'}
                                    />
                                </FormGroup>
                            </div>
                            <div className="col-md-8">

                                <FormGroup label={"Chiến dịch"}>
                                    <ComboboxChienDich value={formData.dm_chiendich_id}
                                        width={"100%"}
                                        namhoc={formData.nam_hoc}
                                        showClearButton={true}
                                        onValueChanged={(value) => {
                                            setFormData({ ...formData, dm_chiendich_id: value });
                                        }} />
                                </FormGroup>
                            </div>
                            <div className='col-md-4'>
                                <FormGroup label={"Họ tên"}>
                                    <TextBox
                                        value={formData.ho_ten}
                                        stylingMode="outlined"
                                        onValueChanged={(e) => {
                                            if (e.event) {
                                                setFormData({ ...formData, ho_ten: e.value })
                                                trigger("ho_ten")
                                            }
                                        }}
                                    />
                                    <InValidMessage
                                        name="ho_ten"
                                        defaultValue={formData.ho_ten}
                                        register={register({ required: true })}
                                        errors={errors}
                                        message={'Vui lòng điền họ tên'}
                                    />
                                </FormGroup>
                            </div>
                            <div className='col-md-4'>
                                <FormGroup label={"Ngày sinh"}>
                                    <DateBox
                                        displayFormat={"dd/MM/yyyy"}
                                        value={formData.ngay_sinh}
                                        stylingMode="outlined"
                                        onValueChanged={(e) => {
                                            if (e.event) {
                                                setFormData({ ...formData, ngay_sinh: e.value })
                                                trigger("ngay_sinh")
                                            }
                                        }}
                                    />
                                    <InValidMessage
                                        name="ngay_sinh"
                                        defaultValue={formData.ngay_sinh}
                                        register={register({ required: true })}
                                        errors={errors}
                                        message={'Vui lòng điền ngày sinh'}
                                    />
                                </FormGroup>
                            </div>
                            <div className='col-md-4'>
                                <FormGroup label={"Giới tính"}>
                                    <ComboboxGioiTinh
                                        value={formData.dm_gioitinh_id}
                                        width={"100%"}
                                        onValueChanged={(value) => {
                                            setFormData({ ...formData, dm_gioitinh_id: value })
                                            trigger("dm_gioitinh_id")
                                        }} />
                                    <InValidMessage
                                        name="dm_gioitinh_id"
                                        defaultValue={formData.dm_gioitinh_id}
                                        register={register({ min: 1 })}
                                        errors={errors}
                                        message={'Vui lòng chọn giới tính'}
                                    />
                                </FormGroup>
                            </div>
                            <div className='col-md-6'>
                                <FormGroup label={"Điện thoại liên hệ"}>
                                    <TextBox
                                        value={formData.dien_thoai_lien_he}
                                        stylingMode="outlined"
                                        onValueChanged={(e) => {
                                            if (e.event) {
                                                setFormData({ ...formData, dien_thoai_lien_he: e.value })
                                                trigger("dien_thoai_lien_he")
                                            }
                                        }}
                                    />
                                    <InValidMessage
                                        name="dien_thoai_lien_he"
                                        defaultValue={formData.dien_thoai_lien_he}
                                        register={register({ required: true })}
                                        errors={errors}
                                        message={'Vui lòng điền điện thoại người liên hệ'}
                                    />
                                </FormGroup>
                            </div>
                            <div className='col-md-6'>
                                <FormGroup label={"Người liên hệ"}>
                                    <TextBox
                                        value={formData.nguoi_lien_he}
                                        stylingMode="outlined"
                                        onValueChanged={(e) => {
                                            if (e.event) {
                                                setFormData({ ...formData, nguoi_lien_he: e.value })
                                                trigger("nguoi_lien_he")
                                            }
                                        }}
                                    />
                                    <InValidMessage
                                        name="nguoi_lien_he"
                                        defaultValue={formData.nguoi_lien_he}
                                        register={register({ required: true })}
                                        errors={errors}
                                        message={'Vui lòng điền thông tin người liên hệ'}
                                    />
                                </FormGroup>
                            </div>
                            {!isValidUniqueKey &&
                                <div style={{
                                    color: "red",
                                    paddingLeft: 15,
                                    paddingTop: 10
                                }}>
                                    <p>{translate("Thông tin học sinh đã tồn tại (Họ tên, Ngày sinh, Điện thoại liên hệ)")}</p>
                                </div>
                            }
                            <div className='col-md-12'>
                                <FormGroup label={"Trường đang học"}>
                                    <TextBox
                                        value={formData.truong_dang_hoc}
                                        stylingMode="outlined"
                                        onValueChanged={(e) => {
                                            if (e.event) {
                                                setFormData({ ...formData, truong_dang_hoc: e.value })
                                            }
                                        }}
                                    />

                                </FormGroup>
                            </div>
                            <div className='col-md-12'>
                                <FormGroup label={"Nguồn dữ liệu"}>
                                    <TextBox
                                        value={formData.nguon_du_lieu}
                                        stylingMode="outlined"
                                        onValueChanged={(e) => {
                                            if (e.event) {
                                                setFormData({ ...formData, nguon_du_lieu: e.value })
                                            }
                                        }}
                                    />

                                </FormGroup>
                            </div>
                        </div>
                    </form>

                </Modal.Content>
                <Modal.Actions>
                    <div>
                        <DefaultButton text={"Đóng"} onClick={onCancel} />
                        <PrimaryButton text={id > 0 ? "Cập nhật" : "Thêm mới"} disabled={!isValidUniqueKey} isLoading={isSaving} onClick={handleSubmit} />

                    </div>
                </Modal.Actions>
            </Modal>
        </>
    );
};

export default HoSoSurveyModal;